module.exports = __webpack_public_path__ + "img/5in1Svg.5df57b24.svg";